import React, { Fragment } from 'react';
import { Button, Icon, Grid, Accordion } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { GenericFiltersContainer } from 'Components/filters/container';

const FilterSection = props => {
  const {
    handleClick,
    handleDropDownChange,
    clearFilter,
    fields,
    width,
    activeIndexes,
  } = props;
  return (
    <Grid.Column width={width}>
      <Accordion fluid styled>
        <Accordion.Title
          active={activeIndexes.indexOf(0) === -1}
          index={0}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          <span className="text-orange">Filter Items By</span>
        </Accordion.Title>
        <Accordion.Content active={activeIndexes.indexOf(0) === -1}>
          <Grid className={'remove-spacing'}>
            <GenericFiltersContainer
              fields={fields}
              onChange={handleDropDownChange}
              filterValues={{}}
            />
            <Grid.Column floated={'right'} width={6} textAlign={'right'}>
              <Button
                content="Clear Item Filters"
                type={'button'}
                onClick={clearFilter}
              />
            </Grid.Column>
          </Grid>
        </Accordion.Content>
      </Accordion>
    </Grid.Column>
  );
};

const ItemGridFilterComponent = props => {
  const {
    handleClick,
    handleDropDownChange,
    direction,
    fields,
    clearFilter,
    activeIndexes,
  } = props;
  return (
    <Grid.Row columns={2}>
      {direction ? (
        <Fragment>
          <Grid.Column width={6} />
          <FilterSection
            width={10}
            fields={fields}
            clearFilter={clearFilter}
            handleClick={handleClick}
            handleDropDownChange={handleDropDownChange}
            activeIndexes={activeIndexes}
          />
        </Fragment>
      ) : (
        <Fragment>
          <FilterSection
            width={10}
            fields={fields}
            clearFilter={clearFilter}
            handleClick={handleClick}
            handleDropDownChange={handleDropDownChange}
            activeIndexes={activeIndexes}
          />
          <Grid.Column width={6} />
        </Fragment>
      )}
    </Grid.Row>
  );
};

ItemGridFilterComponent.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  activeIndexes: PropTypes.array.isRequired,
  handleClick: PropTypes.func,
  handleDropDownChange: PropTypes.func,
  clearFilter: PropTypes.func,
  direction: PropTypes.bool,
};

ItemGridFilterComponent.defaultProps = {
  direction: true,
  handleClick: () => {},
  handleDropDownChange: () => {},
  clearFilter: () => {},
};

export default ItemGridFilterComponent;



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/components/storageLocation/ItemGridFilter.js